import styled from 'styled-components';

export const PopoverContainer = styled.div`
  position: relative;
  z-index: 10;
`;